import i18n from "~/i18n";

export const billableStatusLabels = {
  0: i18n.t("Not billable"),
  1: i18n.t("Billable"),
  2: i18n.t("Pending payment"),
  3: i18n.t("Paid"),
};

export const locationTranslationMap = {
  project: i18n.t("Directly on project"),
  task: i18n.t("Tasks"),
};

export const dateTranslationMap = [
  { id: "this_week", name: i18n.t("This Week") },
  { id: "last_week", name: i18n.t("Last Week") },
  { id: "this_month", name: i18n.t("This Month") },
  { id: "last_month", name: i18n.t("Last Month") },
  { id: "this_quarter", name: i18n.t("This Quarter") },
  { id: "last_quarter", name: i18n.t("Last Quarter") },
  { id: "this_year", name: i18n.t("This Year") },
  { id: "last_year", name: i18n.t("Last Year") },
];

export const editableBillableStatusOptions = [
  {
    id: 0,
    name: i18n.t("Not billable"),
  },
  {
    id: 1,
    name: i18n.t("Billable"),
  },
  {
    id: 2,
    name: i18n.t("Pending payment"),
  },
  {
    id: 3,
    name: i18n.t("Paid"),
  },
];

export const budgetingTypeOptions = {
  fixed: { id: "fixed", name: i18n.t("Fixed Price") },
  pay_as_you_go: { id: "pay_as_you_go", name: i18n.t("Time and Expenses") },
  not_billable: { id: "not_billable", name: i18n.t("Non-Billable") },
};
